// src/modules/coding-opportunities3/IAsystem/mappers/codingOps.flatten.js

export function flattenCodingOpsToText(codingOps = []) {
  const arr = Array.isArray(codingOps) ? codingOps : [];
  return arr
    .map((o, i) => {
      const id = o.codingOpportunityId ?? o.id ?? `op_${i}`;
      return (
        `--- OPPORTUNITY START ---\n` +
        `codingOpportunityId: ${id}\n` +
        `raw: ${JSON.stringify(o)}\n` +
        `--- OPPORTUNITY END ---\n`
      );
    })
    .join("\n");
}
